import React from "react";
import { useTranslation } from "react-i18next";

import { fetchAllOauthClients } from "@admin/api/client";
import { showErrorToast } from "@shared/toasts/Toasts";

export const useGetOauthClients = () => {
    const [data, setData] = React.useState<API.OauthClient[]>([]);
    const [isLoading, setIsLoading] = React.useState(true);

    const { t } = useTranslation(["pages"]);

    React.useEffect(() => {
        setIsLoading(true);
        void fetchAllOauthClients()
            .then((response) => setData(response.model))
            .catch((error) => {
                const err = error as Error;
                showErrorToast(err?.message || t("pages:adminOauthClientsPage.toast.oauthClientsFetchError"));
            })
            .finally(() => setIsLoading(false));
    }, [t]);

    return { data, isLoading };
};
